module.exports = __webpack_public_path__ + "img/boc.8ebf917a.svg";